import fastdom from "fastdom"

import idleCallback from "../helpers/idle-callback"

/**
 * Collects tasks (functions) into a Map by name and executes them.
 * The execution may be different. It has 3 types of async execution and 1 synchronous.
 * Assumes the Pool instance is provided to each instance of a plugin to push tasks.
 * Then, TableController calls exec method providing a task name (depends on a method).
 * Tasks execution has to be in a particular order:idle -> measure -> mutate
 * @returns {Object} The Pool Interface
 */
function Pool() {
  const tasks = new Map()

  const api = {
    push(taskName, task) {
      if (!tasks.has(taskName)) tasks.set(taskName, [])

      tasks.get(taskName).push(task)
    },
    exec(taskName, async, next) {
      const fns = tasks.get(taskName)

      if (!fns) {
        next(null)
        return
      }

      function run() {
        try {
          fns.forEach((task) => {
            task()
          })
          tasks.delete(taskName)
          next(null)
        } catch (err) {
          tasks.clear()
          next(err)
        }
      }

      if (async === "idle") {
        idleCallback(fns, (err) => {
          if (err) {
            next(err)
            return
          }

          tasks.delete(taskName)
          next(null)
        })
        return
      }

      if (async === "mutate") {
        fastdom.mutate(() => run())
        return
      }

      run()
    },
  }

  return Object.freeze(api)
}

export default Pool
